import { connect } from "react-redux";

function EmbeddedSectionViewComponent({
  embeddedSection = null,
  user,
  community,
  ...rest
}) {
  if (!embeddedSection) {
    return <div className="text-red-500">Section Data missing!</div>;
  }

  const { embedCode, name } = embeddedSection;

  const parsedEmbedCode = parseData(embedCode, user, community);

  return (
    <iframe
      srcDoc={parsedEmbedCode}
      title={name}
      style={{ width: "100%", height: "calc(100vh - 150px)" }}
      {...rest}
    />
  );
}

function parseData(embedCode = "", user, community = {}) {
  // replace variables
  let parsedEmbedCode = embedCode;
  const hasAuthTokenEmbedEnabled = community?.configuration?.hasAuthTokenEmbedEnabled ?? false;

  if (user) {
    parsedEmbedCode = embedCode
      .replace(/\{\{userFullName\}\}/g, user.name)
      .replace(/\{\{userEmail\}\}/g, user.email)
      .replace(/\{\{userId\}\}/g, user.id)
      .replace(/\{\{userMobile\}\}/g, user.mobile)
      .replace(/\{\{countryCode\}\}/g, user.countryCode)
      .replace(/\{\{communityRole\}\}/g, community.myRole);

    if (hasAuthTokenEmbedEnabled) {
      parsedEmbedCode = parsedEmbedCode
        .replace(/\{\{authToken\}\}/g, user.token);
    }
  }
  // replace pattern {!!variable!!}
  // parsedEmbedCode = parsedEmbedCode.replace(/\{!!(.*?)!!\}/g, (match, p1) => {
  //     return eval(p1);
  // });
  return parsedEmbedCode;
}

const EmbeddedSectionView = connect((s) => ({
  user: s.auth,
  community: s.community,
}))(EmbeddedSectionViewComponent);

export default EmbeddedSectionView;
